import { initialize } from './helpers/init'
import loadBundles from './helpers/loadBundles'
import Menu from './components/menu';
import initAlpine from './components/alpine';


import './helpers/validations';
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import './utils/add-to-calendar';

document.body.classList.remove('no-js')
//lazyload() // Initialise lazyload of images

document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
    document.body.classList.remove('is-loading')
    document.body.classList.add('is-loaded-complete')

    initialize('menu', Menu)

  }
}

/* Conditionally load bundles */

loadBundles()

// Load Apline

initAlpine();

